import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roleSettings: [
    {
      roleId: '',
      fieldId: '',
      status: true,
      permission: [],
    },
  ],
};

export const createRoleSettings = createSlice({
  name: 'createRoleSettings',
  initialState,
  reducers: {
    updateRoleSettingsInfo: (state, action) => {
      state.roleSettings = action.payload;
    },
    updateRoleSettingsInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.roleSettings[field] = value;
    },
    updateRoleSettingsInfoWithId: (state, action) => {
      const { id, value } = action.payload;
      !state.roleSettings
        .find((roleSetting) => roleSetting.fieldId === id)
        .permission.includes(value)
        ? (state.roleSettings.find(
            (roleSetting) => roleSetting.fieldId === id
          ).permission = [
            ...state.roleSettings.find(
              (roleSetting) => roleSetting.fieldId === id
            ).permission,
            value,
          ])
        : (state.roleSettings.find(
            (roleSetting) => roleSetting.fieldId === id
          ).permission = state.roleSettings
            .find((roleSetting) => roleSetting.fieldId === id)
            .permission.filter((perm) => perm !== value));
    },
    clearRoleSettingsInfo: (state) => {
      state.roleSettings = initialState.roleSettings;
    },
  },
});

export const roleSettingsDetailSelector = (state) =>
  state.createRoleSettings.roleSettings;
export const {
  updateRoleSettingsInfo,
  updateRoleSettingsInfoField,
  clearRoleSettingsInfo,
  updateRoleSettingsInfoWithId,
} = createRoleSettings.actions;

export const createRoleSettingsReducer = createRoleSettings.reducer;
export const createRoleSettingsReducerName = createRoleSettings.name;

export default createRoleSettings.reducer;
